import gql from 'graphql-tag';
import STATUS_FRAGMENT from './STATUS_FRAGMENT';

export const MODIFY_SERVICE_RUN_WAREHOUSE = gql`
	mutation modifyServiceRunWarehouse (
		$serviceRunId: ID!,
		$warehouseId: ID!,
		$isReturnWarehouse: Boolean, 
	) {
		modifyServiceRunWarehouse (
			serviceRunId: $serviceRunId,
			warehouseId: $warehouseId,
			isReturnWarehouse: $isReturnWarehouse,
		)
		{
			...serviceRunStatus
		}
	}
	${STATUS_FRAGMENT}
`;
